import React from 'react';

import { useEventTracker } from '../hooks/useEventTracker';

/**
 * Invisible component that activates event tracking for authenticated users.
 * Must be rendered inside AuthProvider.
 */
export const EventTrackerProvider: React.FC = () => {
  useEventTracker();

  return null;
};

export default EventTrackerProvider;
